<template>
  <dialog-component
    :title="getTitle"
    :containerWidth="getIsMobile ? '100%' : '40%'"
    :visible="dialogFormVisible"
    @before-close="closeRolePopUp"
    v-loading="loading"
  >
    <el-form :model="newRoleForm" label-position="top" class="!pb-4">
      <div class="!mb-4">
        <p class="text-xs 2xl:!text-sm m-0 !mb-1 text-black-600">
          Role Title
          <span class="text-danger">*</span>
        </p>
        <el-input
          v-model="newRoleForm.title"
          autocomplete="off"
          placeholder="Enter Role Name"
        ></el-input>
      </div>
      <div class="!mb-2">
        <p class="text-xs 2xl:!text-sm m-0 !mb-1 text-black-600">Groups List</p>
        <el-select
          v-model="newRoleForm.allowed_groups"
          multiple
          collapse-tags
          placeholder="Select Groups"
          filterable
          class="w-full"
        >
          <el-option
            v-for="groupInfo in allEntitiesGroups"
            :key="groupInfo._id"
            :label="groupInfo.name"
            :value="groupInfo._id"
          ></el-option>
        </el-select>
      </div>
      <span style="font-weight: 500; color: var(--brand-500)" v-if="!roleId">
        Note: After saving the role, it's essential to allocate customized permissions to the
        relevant user roles.
      </span>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <div class="flex items-center justify-end !gap-4">
        <el-button @click="dialogFormVisible = false" plain>Cancel</el-button>
        <el-button class="!border-brand-500 !border !py-2 !m-0" type="primary" @click="onSubmit">
          Save
        </el-button>
      </div>
    </span>
    <!-- <span class="error" v-if="getError && !getError.success">
      {{ getError.message }}</span
    > -->
  </dialog-component>
</template>

<script>
  import { mapGetters } from 'vuex';
  export default {
    props: ['existedRole'],
    data() {
      return {
        dialogFormVisible: false,
        allEntitiesGroups: [],
        newRoleForm: {
          title: '',
          allowed_groups: [],
        },
        loading: false,
      };
    },
    computed: {
      ...mapGetters('navigationOpen', ['getIsMobile', 'getIsRSOpen']),
      ...mapGetters('roles', ['getRoleErrors', 'getSuccess']),

      ...mapGetters('entityGroups', ['getAllEntityGroupsData']),
      getTitle() {
        return this.existedRole._id ? 'Update Role' : 'Add New Role';
      },
    },
    mounted() {
      this.clearErrors();
      this.fetAllEntityGroups();
      this.dialogFormVisible = true;
      if (this.existedRole) {
        this.newRoleForm = { ...this.existedRole };
        this.roleId = this.existedRole._id;
      }
    },
    methods: {
      clearErrors() {
        this.$store.dispatch('roles/resetErrors');
      },
      // :disabled="!newRoleForm.title || !newRoleForm.allowed_groups"
      async onSubmit() {
        if (this.newRoleForm && !this.newRoleForm.title) {
          this.$message.error('Please add Role title.!');
        } else {
          this.loading = true;
          this.newRoleForm.title = this.newRoleForm.title.replace(/^\s+|\s+$/gm, '');
          if (this.newRoleForm.title) {
            if (this.roleId) {
              await this.updateRole();
            } else {
              await this.addRole();
            }
            this.loading = false;
          } else {
            this.loading = false;
            this.$message.warning('Please Fill the role title');

            return;
          }
        }
      },

      async updateRole() {
        try {
          this.newRoleForm.title = this.newRoleForm.title.replace(/^\s+|\s+$/gm, '');
          let params = {
            _id: this.roleId,
            ...this.newRoleForm,
          };
          await this.$store.dispatch('roles/updateRole', params);
          if (this.getSuccess.success) {
            this.$notify.success({
              title: 'Success',
              message: 'Role Added Successfully.',
            });
            this.closeRolePopUp(true);
            await this.$store.dispatch('roles/resetErrors');
          } else {
            throw 'Error';
          }
        } catch (err) {
          // if (this.getRoleErrors.status_code!==200) {
          this.$notify.error({
            title: 'Error',
            message: this.getRoleErrors.message
              ? this.getRoleErrors.message
              : 'Error at Adding role',
          });
          // }
          console.log('updateRole', err);
        }
      },
      async addRole() {
        try {
          let params = {
            ...this.newRoleForm,
          };
          await this.$store.dispatch('roles/createRole', params);
          if (this.getSuccess.success) {
            this.$notify.success({
              title: 'Success',
              message: 'Role Added Successfully.',
            });
            this.closeRolePopUp(true);
            await this.$store.dispatch('roles/resetErrors');
          } else {
            throw 'Error';
          }
        } catch (err) {
          // if (this.getRoleErrors.status_code!==200) {
          this.$notify.error({
            title: 'Error',
            message: this.getRoleErrors.message
              ? this.getRoleErrors.message
              : 'Error at Adding role',
          });
          // }
          console.log('addRole', err);
        }
      },

      closeRolePopUp(status = false) {
        this.$emit('close', status);
        this.$store.dispatch('roles/resetErrors');
      },

      async fetAllEntityGroups() {
        this.loading = true;
        let params = {
          get_all: true,
        };
        await this.$store.dispatch('entityGroups/fetEntityGroupsData', params);
        this.allEntitiesGroups = this.getAllEntityGroupsData
          ? this.getAllEntityGroupsData.data
          : [];
        this.loading = false;
      },
    },
  };
</script>

<style>
  .err {
    color: #c14e4e;
  }

  .clearfix:before,
  .clearfix:after {
    display: table;
    content: '';
  }

  .clearfix:after {
    clear: both;
  }
</style>
<style lang="scss" scoped>
  .btn-class {
    display: flex;
  }
</style>
<style scoped>
  .el-button.is-plain {
    color: var(--black-500);
    background-color: transparent;
    border-color: var(--black-500);
  }

  .el-button.is-plain:hover {
    color: var(--primary-color-brand);
    background-color: var(--brand-100);
    border-color: var(--primary-color-brand);
  }
</style>
